import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class AtaService {
  async getAll(
    projectId: string,
    query?: models.GetAtaProjectQuery,
  ): Promise<models.ListAtaResponse[]> {
    const atas = await appHttpService.request
      .url(`/atas/${projectId}`)
      .query(query || {})
      .get()
      .json<models.ListAtaResponse[]>();
    return atas;
  }

  async getAtasWithCost(
    projectId: string,
    query?: models.GetAtaProjectQuery,
  ): Promise<models.GetAtasWithCostResponse> {
    const atas = await appHttpService.request
      .url(`/projects/${projectId}/atas`)
      .query(query || {})
      .get()
      .json<models.GetAtasWithCostResponse>();
    return atas;
  }

  async getOnlyForcastedAtas(
    projectId: string,
  ): Promise<models.ListAtaResponse[]> {
    const atas = await appHttpService.request
      .url(`/atas/forecasted/${projectId}`)
      .get()
      .json<models.ListAtaResponse[]>();
    return atas;
  }

  async updateAtaInvoiceComment(
    id: string,
    body: models.UpdateAtaListItemBody,
  ): Promise<models.ListAtaResponse> {
    const ata = await appHttpService.request
      .url(`/atas/listitem/${id}`)
      .put(body)
      .json<models.ListAtaResponse>();
    return ata;
  }

  async get(id: string): Promise<models.GetAtaResponse> {
    const ata = await appHttpService.request
      .url(`/atas/ata/${id}`)
      .get()
      .json<models.GetAtaResponse>();
    return ata;
  }

  async post(body: models.UpCreateAtaBody): Promise<models.GetAtaResponse> {
    const ata = await appHttpService.request
      .url(`/atas/ata`)
      .post(body)
      .json<models.GetAtaResponse>();
    return ata;
  }

  async put(
    id: string,
    body: models.UpCreateAtaBody,
  ): Promise<models.GetAtaResponse> {
    const ata = await appHttpService.request
      .url(`/atas/ata/${id}`)
      .put(body)
      .json<models.GetAtaResponse>();
    return ata;
  }

  async exportToCsv(projectId: string): Promise<string> {
    const csv = await appHttpService.request
      .url(`/atas/${projectId}/export`)
      .post()
      .text();
    return csv;
  }

  async getDocument(projectId: string, ataId: string): Promise<Blob | null> {
    // 404 means "no document stored yet" — the dedicated `.notFound()` catcher
    // runs before the global `catcherFallback`, so it resolves to null instead
    // of surfacing an error toast.
    return appHttpService.request
      .url(`/atas/${projectId}/atas/${ataId}/document`)
      .get()
      .notFound(() => null)
      .res(async (res) => (res ? await res.blob() : null));
  }

  async uploadDocument(
    projectId: string,
    ataId: string,
    file: File,
  ): Promise<models.AtaDocumentMetadata> {
    const formData = new FormData();
    formData.append('file', file);
    return appHttpService.request
      .url(`/atas/${projectId}/atas/${ataId}/document`)
      .post(formData)
      .json<models.AtaDocumentMetadata>();
  }

  async deleteDocument(projectId: string, ataId: string): Promise<void> {
    await appHttpService.request
      .url(`/atas/${projectId}/atas/${ataId}/document`)
      .json({})
      .delete()
      .res();
  }
}
export const ataService = new AtaService();
